import { render, staticRenderFns } from "./AddStepButton.vue?vue&type=template&id=0fd3af8a&scoped=true&lang=pug"
import script from "./AddStepButton.vue?vue&type=script&lang=js"
export * from "./AddStepButton.vue?vue&type=script&lang=js"
import style0 from "./AddStepButton.vue?vue&type=style&index=0&id=0fd3af8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd3af8a",
  null
  
)

export default component.exports